import {Component, Input, OnInit} from '@angular/core';

import {Step} from 'projects/mydocma/import-export/src/lib/stepper/step/step';
import {StepComponent, StepData} from 'projects/mydocma/import-export/src/lib/stepper/step/step.component';
import {StepperService} from 'projects/mydocma/import-export/src/lib/stepper/stepper.service';
import {timer} from 'rxjs';
import {map} from 'rxjs/operators';
import {NavigationService} from '../navigation.service';

@Component({
    selector: 'app-stepper-navigation-step1',
    templateUrl: './step1.component.html',
    styleUrls: ['./step1.component.scss']
})
export class Step1Component implements OnInit, StepComponent {

    @Input()
    step: Step;


    selectedType = 0;


    constructor(private readonly stepperService: StepperService,
                private readonly navigationService: NavigationService) {
    }

    ngOnInit() {
    }

    enter() {
        //this.stepperService.setStepData(this.step, { valid: true, error: '', data: {} });
    }

    async onSelectedTypeChanged(value) {
        const step2 = this.stepperService.getStepByName('step2')
        
        if (value.value === 2) {
            await this.stepperService.setStepData(step2, {hidden: true});
        } else {
            await this.stepperService.setStepData(step2, {hidden: false});
        }
    }

    async validate(): Promise<StepData> {
        if (this.selectedType < 1) {
            return {valid: false}
        } else {
            this.navigationService.loading = true;
            // const stepData = {
            //         valid: true,
            //         data: this.selectedType
            //       };

            const stepData = await timer(0).pipe(
                map(() => {
                    return {
                        valid: true,
                        data: this.selectedType
                    }
                })).toPromise();
            if (this.step.data && this.step.data !== this.selectedType) {
                const step2 = this.stepperService.getStepByName('step2')
                await this.stepperService.setStepData(step2, {valid: false});
            }


            this.navigationService.loading = false;

            return stepData;
        }
    }

    reset() {
        this.selectedType = 0;
    }

    async next() {
        await this.stepperService.nextStep();
    }
}
